import { useField } from "formik";
import React from "react";
import { Form } from "react-bootstrap";

type InlineInputFieldProps = {
    className?: string;
    name: string;
    type: string;
    maxLength?: number;
    onInput?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    ariaLabelledBy?: string;
    required?: boolean;
};

const InlineInputField = ({
    className,
    name,
    type,
    maxLength,
    onInput,
    ariaLabelledBy,
    required,
}: InlineInputFieldProps): JSX.Element => {
    const [field, meta] = useField(name);
    const ariaLabel = ariaLabelledBy ? ariaLabelledBy : `notification-help-${name}`;

    return (
        <Form.Group
            className={`d-flex align-items-center ${className || ""}`}
            controlId={name}
        >
            <Form.Control
                type={type}
                value={field.value}
                onChange={field.onChange}
                isInvalid={!!meta.error}
                maxLength={maxLength}
                onInput={onInput}
                className={"amount-form-control"}
                aria-labelledby={ariaLabel}
                aria-describedby={`notification-help-${name}`}
                required={required}
            />
            <Form.Control.Feedback type="invalid" className="mt-0 ms-3" id={`notification-help-${name}`} style={{color: 'red'}}>
                {meta.error}
            </Form.Control.Feedback>
        </Form.Group>
    );
};

export default InlineInputField;
